import { Component, inject } from '@angular/core';
import { TuiLoader, TuiRoot } from '@taiga-ui/core';
import { PrizmIconsFullRegistry, PrizmIconsRegistry } from '@prizm-ui/icons/core';
// eslint-disable-next-line import/no-namespace
import * as allBaseIcons from '@prizm-ui/icons/base/source';
// eslint-disable-next-line import/no-namespace
import * as fullBaseIcons from '@prizm-ui/icons/full/source';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { DateTimeService } from 'ngx-register-base';
import { TIME_ZONES } from './constants/date-time.constants';

@Component({
  selector: 'uzu-root',
  standalone: true,
  imports: [RouterOutlet, TuiRoot, TuiLoader, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less',
})
export class AppComponent {
  readonly iconsFullRegistry = inject(PrizmIconsFullRegistry);
  readonly iconsBaseRegistry = inject(PrizmIconsRegistry);
  readonly _dtService = inject(DateTimeService);
  private readonly router = inject(Router);

  private readonly _navLoading$ = new BehaviorSubject<boolean>(false);
  public readonly navLoading$ = this._navLoading$.asObservable();

  constructor() {
    const tz = TIME_ZONES[0];
    this._dtService.currentTimeTZ.picked_time_zone = tz;

    this.iconsBaseRegistry.registerIcons(Object.values(allBaseIcons));
    this.iconsFullRegistry.registerIcons(Object.values(fullBaseIcons));
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._navLoading$.next(true);
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this._navLoading$.next(false);
      }
    });
  }
}
